import { useTranslation } from 'react-i18next';
import { type ActionMethods, type UserSelfPageData } from '..';
import PageTitle from '../PageTitle';
import AuthenticatorContent from './AuthenticatorContent';

const useAuthenticatorPageData = (actions: ActionMethods) => {
    const { t } = useTranslation('userSelf');
    const page: UserSelfPageData = {
        type: 'authenticator2FA',
        title: <PageTitle title={t('userSelf:authenticatorSettings.title')} />,
        body: <AuthenticatorContent onDone={actions.goBackToViewProfile} />,
        onMenuItemClicked: actions.goToAuthenticator,
        onCloseOrBackClicked: actions.goBackToViewProfile,
    };

    return page;
};

export default useAuthenticatorPageData;
